import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPagination from '../../components/molecules/ExPagination';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  receiptStatus: {
    borderRadius: '27px',
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: 700,
    padding: '4px 8px',
    textAlign: 'center',
    width: 'fit-content'
  },
  receiptStatusNotApproval: {
    backgroundColor: '#802A2E'
  },
  receiptStatusOK: {
    backgroundColor: '#A9ADB0'
  },
  receiptStatusNG: {
    backgroundColor: '#FF545C'
  },
  receiptStatusAdmin: {
    backgroundColor: '#16C4FF'
  },
  textAlignCenter: {
    textAlign: 'center'
  },
  userNameCell: {
    width: '260px',
    whiteSpace: 'break-spaces',
    wordBreak: 'keep-all'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withHandlers({
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    listReceipt,
    totalCount,
    rowsPerPage,
    page,
    offset,
    handleChangePage,
    selectedPage,
    handleChangeRowsPerPage,
    handleOpenReceiptDetail
  }) => {
    return (
      <div className={classes.root}>
        <div className={classes.scrollTable}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>承認状況</TableCell>
                <TableCell className={classes.textAlignCenter}>
                  承認&レシート詳細
                </TableCell>
                <TableCell>利用者名</TableCell>
                <TableCell>利用者ID</TableCell>
                <TableCell>レシート登録日時</TableCell>
                <TableCell>利用店舗ID</TableCell>
                <TableCell>利用店舗名</TableCell>
                <TableCell>利用グループ名</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listReceipt &&
                listReceipt.map(receipt => {
                  let statusElement = '';
                  if (receipt.status === 2) {
                    statusElement = (
                      <div
                        className={classNames(
                          classes.receiptStatus,
                          classes.receiptStatusNotApproval
                        )}
                      >
                        承認保留
                      </div>
                    );
                  } else if (receipt.status === 1) {
                    statusElement = (
                      <div
                        className={classNames(
                          classes.receiptStatus,
                          classes.receiptStatusOK
                        )}
                      >
                        承認済み
                      </div>
                    );
                  } else if (receipt.status === 3) {
                    statusElement = (
                      <div
                        className={classNames(
                          classes.receiptStatus,
                          classes.receiptStatusAdmin
                        )}
                      >
                        承認待ち
                      </div>
                    );
                  } else if (receipt.status === 4) {
                    statusElement = (
                      <div
                        className={classNames(
                          classes.receiptStatus,
                          classes.receiptStatusNG
                        )}
                      >
                        非承認
                      </div>
                    );
                  }

                  return (
                    <TableRow key={receipt.receiptId}>
                      <TableCell>{statusElement}</TableCell>
                      <TableCell className={classes.textAlignCenter}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleOpenReceiptDetail(receipt.id);
                          }}
                        >
                          確認
                        </Button>
                      </TableCell>
                      <TableCell>
                        <div className={classes.userNameCell}>
                          {receipt.userName}
                        </div>
                      </TableCell>
                      <TableCell>{receipt.userId}</TableCell>
                      <TableCell>{receipt.createdAt}</TableCell>
                      <TableCell>{receipt.shopId}</TableCell>
                      <TableCell>{receipt.shopName}</TableCell>
                      <TableCell>{receipt.groupNames}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={listReceipt}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
